/* eslint-disable import/no-cycle */
import actions from './actions';
import mutations from './mutations';

export const initialState = () => ({
  selectedFilters: {
    state: null,
    startDate: -1,
    endDate: -1,
    reportType: null,
    advertiserId: null,
    campaignId: null,
  },
  selectedAdvertiserDetails: {},
});

const state = initialState();

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
